import React, { useEffect, useState } from 'react';
import FeatheredOverflowContainer from '~/components/FeatheredOverflowContainer';
import ShopLinkTitleHack from '~/components/Links/ShopLinkTitleHack';
import useFacetFiltering from '~/contexts/facetFiltering/useFacetFiltering';
import { fireAppliedFilter } from '~/services/analytics/events/search';
import doesLanderQueryContainADetail from '~/utils/doesLanderQueryContainADetail';

interface Props {
  headerType?: 'h1' | 'h2' | 'h3';
}

// Scary logic going on in here.
// Pressing a detail doesn't immediately hide the section
// while you're navigating in the background. It's really jarring, so
// fix it this way: only evaluate the display state when facets changes.
// Facets will change when the new results come in, not immediately when a
// state change is made.

const TopDetailSelection: React.FC<Props> = ({ headerType: Header = 'h3' }) => {
  const {
    category,
    facets,
    lander,
    changeFacetSelection,
    isSelected,
    transferableFilterState,
  } = useFacetFiltering();

  const firstFacet = facets.filter(
    f => f.slug !== 'category' && f.slug !== 'sale',
  )[0];

  const evaluateHidden = () => {
    if (!firstFacet) {
      return true;
    }

    if (!firstFacet.children || firstFacet.children.length === 0) {
      return true;
    }

    if (isSelected(firstFacet)) {
      return true;
    }
  };

  const [hidden, setHidden] = useState(evaluateHidden);

  useEffect(() => {
    setHidden(evaluateHidden());
  }, [facets]);

  if (hidden) {
    return null;
  }

  if (!category || (category && !category.show_top_detail)) {
    return null;
  }

  const landerQueryContainsMoreThanJustCategoryOrModel =
    doesLanderQueryContainADetail(lander);

  return (
    <div className="container my-4">
      <Header className="mb-2 text-lg">Shop by {firstFacet.name}</Header>

      <FeatheredOverflowContainer className="flex items-center space-x-2 overflow-x-auto">
        {firstFacet.children
          ?.filter(
            child =>
              !child.name.startsWith('Unknown') &&
              !child.name.startsWith('Other'),
          )
          .map(child => {
            if (
              lander &&
              child.url &&
              !landerQueryContainsMoreThanJustCategoryOrModel
            ) {
              return (
                <ShopLinkTitleHack
                  internalRouter
                  key={child.id}
                  path={child.url}
                  query={transferableFilterState}
                  className="flex-shrink-0 rounded border px-8 py-4 font-semibold"
                  onClick={() => fireAppliedFilter(firstFacet, child, category)}
                  displayedText={child.name}
                  anchorText={child.destination_lander_name}
                />
              );
            } else {
              return (
                <button
                  key={child.id}
                  className="flex-shrink-0 rounded border px-8 py-4 font-semibold"
                  type="button"
                  onClick={() => {
                    fireAppliedFilter(firstFacet, child, category);
                    changeFacetSelection(firstFacet, child, false, true);
                  }}
                >
                  {child.name}
                </button>
              );
            }
          })}
      </FeatheredOverflowContainer>
    </div>
  );
};

export default TopDetailSelection;
